<template>
  <div class="content">
    <card>
      <div class="row">
        <label class="col-sm-2 col-form-label">블립아티스트추가</label>
        <div class="col-sm-2">
          <base-input placeholder="이름검색" v-model="name">
            <span slot="helpBlock" class="form-text" />
          </base-input>
        </div>
        <div class="col-sm-2">
          <base-button @click="searchArtistByName" type="default">검색</base-button>
        </div>
        <div class="col-sm-2">
          <el-select class="select-primary" size="large" placeholder="아티스트선택" v-model="artistId">
            <el-option v-for="option in artists" class="select-primary" :value="option.id" :label="option.name" :key="option.name" />
          </el-select>
        </div>
        <div class="col-sm-2">
          <base-button @click="addArtistUnit" type="default">추가</base-button>
        </div>
      </div>
    </card>
    <card>
      <div class="row">
        <div class="col-md-2">
          <el-select @change="getArtistUnits" class="select-primary" size="large" placeholder="선택" v-model="state.state">
            <el-option v-for="option in state.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
          </el-select>
        </div>
        <div v-if="state.state === 1" class="col-md-4">
          <base-button @click="setUnitOrder" type="default">노출순서변경</base-button>

          <el-popover trigger="hover" placement="top">
            <div>
              <div class="popover-body">드래그앤드랍으로 노출순서를 변경할 수 있습니다</div>
            </div>
            <base-button slot="reference"> ? </base-button>
          </el-popover>
        </div>
        <base-button @click="setApiRevision" type="default">API REVISION 설정</base-button>
      </div>
    </card>
    <draggable class="row" v-model="units" handle=".handle" group="people" @start="drag = true" @end="drag = false">
      <div class="col-sm-3" v-for="(item, index) in units">
        <card class="card">
          <div class="handle">
            <div class="row">
              <img v-if="item.imageFileUrl" slot="image" class="card-img-top cover-img" v-bind:src="item.imageFileUrl" :alt="item.name" />
              <img v-else src="@/assets/img/blip-logo.png" />
            </div>
            <p class="card-text">아티스트명: {{ item.name }}</p>
            <p class="card-text">블립아티스트명: {{ item.blipName }}</p>
          </div>
          <base-button @click="artistDetail(item.unitId)" @touchstart="artistDetail(item.unitId)" type="default">상세</base-button>
        </card>
      </div>
    </draggable>
  </div>
</template>
<script>
import { Card, BaseInput, BaseButton } from "@/components/index";
import { URLUtils } from "@/util/URLUtils";
import draggable from "vuedraggable";

export default {
  components: {
    Card,
    BaseInput,
    BaseButton,
    draggable,
  },
  async created() {
    await this.getArtistUnits();
  },
  data() {
    return {
      state: {
        state: 1,
        options: [
          { label: "전체", value: null },
          { label: "표시", value: 1 },
          { label: "숨김", value: 0 },
        ],
      },
      name: null,
      units: [],
      artists: [],
      artistId: null,
    };
  },
  methods: {
    async getArtistUnits() {
      const param = URLUtils.objectToQueryString({ isVisible: this.state.state });
      return this.$axios.get(`/artistUnit?${param}`, null).then((res) => {
        this.units = res.data.data;
        for (let i = 0; i < this.units.length; i++) {
          if (this.units[i].imageFileId) {
            this.units[i].imageFileUrl = window.Endpoints.imageServerUrl + this.units[i].imageFileId;
          }
        }
      });
    },
    async searchArtistByName() {
      return this.$axios.get(`/artistUnit/artist?name=${this.name}`).then((res) => {
        this.artists = res.data.data;
        if (this.artists.length > 0) {
          this.artistId = this.artists[0].id;
        }
      });
    },
    async addArtistUnit() {
      if (!this.artistId) {
        Toast.error("아티스트를 선택해주세요");
        return;
      }
      return this.$axios.post("/artistUnit", { artistId: this.artistId }).then((res) => {
        Toast.success("블립아티스트가 '숨김' 상태로 추가되었습니다");
        this.getArtistUnits();
      });
    },
    async setUnitOrder() {
      const units = [];
      this.units.forEach((unit, order) => {
        units.push({ unitId: unit.unitId, order });
      });
      return this.$axios.put("/artistUnit/order", { units }).then((res) => {
        Toast.success("아티스트 노출순서가 변경되었습니다");
        this.getArtistUnits();
      });
    },
    async setApiRevision() {
      return this.$axios.put("/common/apiRevisions", { unitIds: this.units.map((unit) => unit.unitId) }).then((res) => {
        Toast.success("revision 재설정");
      });
    },
    artistDetail(unitId) {
      this.$router.push(`/blipArtist/blipArtistDetail?unitId=${unitId}`);
    },
  },
};
</script>
<style></style>
